import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="circle"></div>
    </div>
  );
};

export default Loading;
